import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './custom-container.scss.js';

class CustomContainer extends s {
    constructor() {
        super(...arguments);
        this.template = '';
        this.containerClassNames = '';
    }
    renderContainer(template) {
        const cleanTemplate = template || '';
        return $ `<div class="custom-container ${cleanTemplate}"><slot></slot></div>`;
    }
    render() {
        return this.renderContainer(this.template);
    }
}
CustomContainer.styles = css_248z;
__decorate([
    e({ type: String })
], CustomContainer.prototype, "template", void 0);
customElements.define('custom-container', CustomContainer);

export { CustomContainer };
